import { render, staticRenderFns } from "./IconInfo.vue?vue&type=template&id=45e02529&scoped=true&"
import script from "./IconInfo.vue?vue&type=script&lang=js&"
export * from "./IconInfo.vue?vue&type=script&lang=js&"
import style0 from "./IconInfo.vue?vue&type=style&index=0&id=45e02529&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e02529",
  null
  
)

export default component.exports